import { render, staticRenderFns } from "./WeekViewProjectEntryComponent.vue?vue&type=template&id=360d53fd&scoped=true&"
import script from "./WeekViewProjectEntryComponent.vue?vue&type=script&lang=ts&"
export * from "./WeekViewProjectEntryComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WeekViewProjectEntryComponent.vue?vue&type=style&index=0&id=360d53fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360d53fd",
  null
  
)

export default component.exports